export const typography = {
  bodyMedium: {
    fontSize: 'body.medium',
    fontWeight: 'body.medium',
    lineHeight: 'body.medium',
    letterSpacing: 'body.medium',
  },
  bodyMediumBold: {
    fontSize: 'body.medium_bold',
    fontWeight: 'body.medium_bold',
    lineHeight: 'body.medium_bold',
    letterSpacing: 'body.medium_bold',
  },
  captionSmall: {
    fontSize: 'caption.small',
    fontWeight: 'caption.small',
    lineHeight: 'caption.small',
    letterSpacing: 'caption.small',
  },
  captionMedium: {
    fontSize: 'caption.medium',
    fontWeight: 'caption.medium',
    lineHeight: 'caption.medium',
    letterSpacing: 'caption.medium',
  },
  captionMediumMedium: {
    fontSize: 'caption.medium_medium',
    fontWeight: 'caption.medium_medium',
    lineHeight: 'caption.medium_medium',
    letterSpacing: 'caption.medium_medium',
  },
  headlineSmallMedium: {
    fontSize: 'headline.small_medium',
    fontWeight: 'headline.small_medium',
    lineHeight: 'headline.small_medium',
    letterSpacing: 'headline.small_medium',
  },
  labelLarge: {
    fontSize: 'label.large',
    fontWeight: 'label.large',
    lineHeight: 'label.large',
    letterSpacing: 'label.large',
  },
  titleMediumMedium: {
    fontSize: 'title.medium_medium',
    fontWeight: 'title.medium_medium',
    lineHeight: 'title.medium_medium',
    letterSpacing: 'title.medium_medium',
  },
  labelMediumMedium: {
    fontSize: 'label.medium_medium',
    fontWeight: 'label.medium_medium',
    lineHeight: 'label.medium_medium',
    letterSpacing: 'label.medium_medium',
  },
} as const;
